import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { _HttpMsgV2 } from "../../../util/Labels";
import { UIUtilLang } from "../../util/Language";
import { NotificacionV2 } from "../NotificacionV2";
import { _ModalThingsBase } from "./ModalThingsBase";
import { ModalThingsUtil as util } from './Utils';

import CAccionPermiso = Entidad.CAccionPermiso;

type IModalThings = util.IModalThings;
type IModalThingsBase1 = util.IModalThingsBase1;

interface IModalThings_LongProccess extends IModalThings {
    Next();
    Previus();
    CancelAndClose();
    // FocusItem(id: string): boolean;
    GetCurrentStepId(): string;
    // GetCurrentStep(): string;
}

export type TModalToALongProccessItem_ValidationResult = (boolean | { IsValid: boolean, Message?: string });
export interface IConfigModalToALongProccessItem {
    Id: string;
    Title: string;
    /** Personaliza contenido extra despues del mensaje de confirmación */
    OnDrawContent: (content: TSelectionHTML<"div">, modalThings: IModalThings) => void;
    OnFocusContent?: (content: TSelectionHTML<"div">, modalThings: IModalThings_LongProccess) => void;
    /** @default 500 px */
    Width?: number;
    Height?: string;
    NextID?: (string | ((modalThings: IModalThings_LongProccess) => string));
    PreviousID?: (string | ((modalThings: IModalThings_LongProccess) => string));
    /** Valida current step para evaluar si se puede enfocar el elemento siguiete */
    OnValideStep?: (content: TSelectionHTML<"div">, modalThings: IModalThings_LongProccess) => TModalToALongProccessItem_ValidationResult | Promise<TModalToALongProccessItem_ValidationResult>;

    OnAccept?: (modalThings: IModalThings) => Promise<DataDRequest.IRequestResponseA<any>>;
}
// type TConfigModalToALongProccessSteps = { [key: string]: IConfigModalToALongProccessItem<any> };
// type TConfigModalToALongProccessSteps<T> = {
//     [k in keyof T]: IConfigModalToALongProccessItem<keyof T & string>;
// }[keyof T]

interface IConfigModalToALongProccess extends Pick<IModalThingsBase1, "Modulo" | "Action" | "IdsEscuelas" | "LangModuleKeyInContext"> {
    /** Si se define "Action", por default toma la cadena del key del enum, a menos que se defina */
    AccionToHttpMessage?: string;

    StepsConfig: IConfigModalToALongProccessItem[];
    //SetConfig: <TStepsConfig extends TConfigModalToALongProccessSteps<TStepsConfig>>() => TStepsConfig2;
    StartEndIds: [string, string];
    OnClose?: () => void;
}

// type TConfigModalToALongProccessKeys = keyof TConfigModalToALongProccessSteps<undefined>;

/**
 * Modal especial para gestionar procesos largos o multi-etapas.
 * Permite configurar pasos personalizados con validaciones, navegación y acciones específicas.
 */
export function _ModalToALongProccess(config: IConfigModalToALongProccess) {
    type TStep = {
        readonly Config: IConfigModalToALongProccessItem;
        Content: TSelectionHTML<"div", any, any>;
        /**
         * @param valideCurrentStep @default true
         */
        Next(valideCurrentStep?: boolean): void;
        Previous(): void;
    };

    const finalConfig: IConfigModalToALongProccess = {
        ... <IConfigModalToALongProccess>{
            // Width: 500,
            AccionToHttpMessage: CAccionPermiso[config.Action]
        },
        ...config
    }

    const steps = new Map<string, TStep>(finalConfig.StepsConfig.map(d => ([
        d.Id,
        {
            Config: {
                ...<IConfigModalToALongProccessItem>{
                    Width: 500
                },
                ...d
            },
            Content: null as TSelectionHTML<"div">,
            Next: null,
            Previous: null
            // ModalThings: null as IModalStepItem_ModalThings
        }
    ])));

    let modalThings: IModalThings_LongProccess;
    let currentStepFocus: TStep;

    const fnExtendsModalThingsFunctions = () => {
        modalThings.CancelAndClose = () => {
            modalThings.Modal._Ocultar();
        }

        modalThings.Next = () => {
            currentStepFocus.Next();
        }

        modalThings.Previus = () => {
            currentStepFocus.Previous();
        }

        modalThings.GetCurrentStepId = () => {
            return currentStepFocus.Config.Id;
        }
    }

    const fnCreateStepModalThings = function (currentStepConfig: IConfigModalToALongProccessItem): TSelectionHTML<"div"> {
        const isFirstStep = Boolean(!modalThings);
        const stepBuilding = steps.get(currentStepConfig.Id);

        // >> Lang context fix
        const langContextTitle = util.GetLangContext(finalConfig.LangModuleKeyInContext, currentStepConfig.Title, finalConfig.Modulo, finalConfig.Action);

        // >> El primer elemento crea ModalThings
        modalThings = _ModalThingsBase(langContextTitle.StringTag, currentStepConfig.Width, currentStepConfig.Id, modalThings, currentStepConfig.Height) as IModalThings_LongProccess;

        if (isFirstStep) {
            fnExtendsModalThingsFunctions();
        }

        currentStepConfig.OnDrawContent(modalThings.CurrentBody, modalThings);

        // >> On moving next anf previous
        const getStepId = function (getId: (string | ((modalThings: IModalThings_LongProccess) => string))): string {
            if (getId && !(typeof getId == "string")) {
                return getId(modalThings);
            }
            return getId as string;
        }
        stepBuilding.Next = (valideCurrentStep = true) => fnStepFocus(getStepId(currentStepConfig.NextID), valideCurrentStep);
        stepBuilding.Previous = () => fnStepFocus(getStepId(currentStepConfig.PreviousID), false);

        return modalThings.CurrentBody;
    }

    const fnEvalValidationResult = (validationResult: TModalToALongProccessItem_ValidationResult) => {
        if ((typeof validationResult == "boolean") && !validationResult) {
            return false;
        }
        else if (validationResult != true && !validationResult.IsValid) {
            if (validationResult.Message) {
                NotificacionV2._Mostrar(validationResult.Message, "ADVERTENCIA");
            }
            return false;
        }
        return true;
    }

    const fnStepFocus = async function (step: string | TStep, valideCurrentStep: boolean): Promise<boolean> {
        const requiredStepFocus = ((typeof step == "string") ? steps.get(step) : step);
        // const currentStepFocus = currentStepFocus;

        if (!requiredStepFocus) {
            console.warn(step, "Required step to focus no found");
            return false;
        }

        // >> Se valida el item actual para poder proceder al siguiente Step
        if (valideCurrentStep && currentStepFocus && currentStepFocus.Config.OnValideStep) {
            let currentStepValidationRes = currentStepFocus.Config.OnValideStep(currentStepFocus.Content, modalThings);
            let validationFinalRes: TModalToALongProccessItem_ValidationResult;

            if (currentStepValidationRes instanceof Promise) {
                modalThings.Progress.attr("oculto", false);
                modalThings.Modal._DeshabilitarBtns();
                await currentStepValidationRes
                    .then((res) => {
                        validationFinalRes = res;
                    })
                    .catch(() => {
                        validationFinalRes = null;
                    });
                modalThings.Progress.attr("oculto", true);
                modalThings.Modal._HabilitarBtns();
            } else {
                validationFinalRes = currentStepValidationRes;
            }

            if (!fnEvalValidationResult(validationFinalRes)) {
                return false;
            }
        }

        if (!requiredStepFocus.Content) {
            // >> Crea Container faltante (muestra y oculta el actual por defecto)
            requiredStepFocus.Content = fnCreateStepModalThings(requiredStepFocus.Config);
        } else {
            // >> Lang context fix
            const langContextTitle = util.GetLangContext(finalConfig.LangModuleKeyInContext, requiredStepFocus.Config.Title, finalConfig.Modulo, finalConfig.Action);
            // >> Focus (Muestra el requerido y oculta el actual)
            _ModalThingsBase(langContextTitle.StringTag, requiredStepFocus.Config.Width, requiredStepFocus.Config.Id, modalThings, requiredStepFocus.Config.Height);
        }

        // >> Ajusta vista de pie
        modalThings.BtnLeft.classed("hide_transparent", false);
        modalThings.BtnRight.classed("hide_transparent", false);

        // >>

        if (requiredStepFocus.Config.OnFocusContent) {
            requiredStepFocus.Config.OnFocusContent(requiredStepFocus.Content, modalThings);
        }

        // >> Configura pie de modal para current step
        const hasPrevious = (requiredStepFocus.Config.PreviousID != null);
        const hasNext = (requiredStepFocus.Config.NextID != null);
        const hasAccept = (requiredStepFocus.Config.OnAccept != null);

        modalThings.BtnLeft
            .text(UIUtilLang._GetUIString("general", "anterior"))
            .classed("hide_transparent", !hasPrevious)
            .on("click", !hasPrevious ? null : () => requiredStepFocus.Previous())

        modalThings.BtnRight
            .text(hasAccept ? UIUtilLang._GetUIString("general", "aceptar") : UIUtilLang._GetUIString("general", "siguiente"))
            .classed("hide_transparent", ((!hasNext && !hasAccept) || (!hasNext && !hasPermission)))
            .on("click", async () => {
                if (modalThings.BtnRight.classed("btn_disable")) return;
                let closeModal = false;
                let continueAvailable = true;
                let validarCurrentStep = true;
                if (hasAccept) {
                    if (requiredStepFocus.Config.OnValideStep) {
                        let validationResult = requiredStepFocus.Config.OnValideStep(currentStepFocus.Content, modalThings);
                        let validationFinalRes: TModalToALongProccessItem_ValidationResult;

                        if (validationResult instanceof Promise) {
                            modalThings.Progress.attr("oculto", false);
                            modalThings.Modal._DeshabilitarBtns();
                            await validationResult
                                .then((res) => {
                                    validationFinalRes = res;
                                })
                                .catch(() => {
                                    validationFinalRes = null;
                                });
                            modalThings.Progress.attr("oculto", true);
                            modalThings.Modal._HabilitarBtns();
                        } else {
                            validationFinalRes = validationResult;
                        }
                        continueAvailable = fnEvalValidationResult(validationFinalRes);
                        validarCurrentStep = false;
                    }
                    if (continueAvailable) {
                        closeModal = await fnOnAccept(requiredStepFocus.Config.OnAccept);
                    }
                }
                if (!continueAvailable) {
                    console.warn("No es posible continuar...");
                    return;
                }
                if (hasNext) {
                    requiredStepFocus.Next(validarCurrentStep);
                }
                else if (closeModal) {
                    modalThings.Modal._Ocultar();
                }
            });

        // >> Success
        currentStepFocus = requiredStepFocus;

        return true;
    }

    const fnOnAccept = async (fn: (modalT) => Promise<DataDRequest.IRequestResponseA>) => {
        modalThings.Modal._DeshabilitarBtns();
        modalThings.Progress.attr("oculto", false);
        // if (finalConf.OnAccept instanceof Promise) {
        const res = await fn(modalThings);
        let successProccess = false;

        if (res) {
            let mess = res.Mensaje;
            if (!mess) {
                if (finalConfig.AccionToHttpMessage)
                    mess = UIUtilLang._GetHTTPMessage(res, finalConfig.AccionToHttpMessage);
                else
                    mess = _HttpMsgV2(res)
            }
            // if (res.Resultado > 0) {
            // modalThings.Modal.met_Ocultar();
            // } else {
            if (res.Resultado > 0) {
                successProccess = true;
            } else {
                modalThings.Modal._HabilitarBtns();
                modalThings.Progress.attr("oculto", true);
            }
            NotificacionV2._Mostrar(mess, res.Resultado > 0 ? "INFO" : "ADVERTENCIA");
        } else {
            modalThings.Modal._HabilitarBtns();
            modalThings.Progress.attr("oculto", true);
        }

        return successProccess;
    }

    const startItem = steps.get(config.StartEndIds[0]);
    //const endItem = steps.get(config.StartEndIds[1]);

    // fnCreateStepModalThings(startItem.Config);
    fnStepFocus(startItem, false);

    // >> Verificacion de permisos
    const hasPermission = util.ActionPermission(config.Action, config.Modulo, config.IdsEscuelas);

    modalThings.Modal._OnClose(finalConfig.OnClose);

    // >> Ajusta vista de pie
    /* modalThings.Modal.prop_FooterSelection
        .style("justify-content", null); */

    /* if (!endItem.Config.OnAccept || !hasPermission) {
        modalThings.Modal.prop_FooterSelection
            .remove();
    } */

    // >>

    if (!hasPermission) {
        return null;
    }

    return modalThings;
}